module.exports = "/assets/dist/img/facebook-logo.png?f579980181cdb861a2a3a9b69819f7f0";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/letter-jackets/site-footer/assets/facebook-logo.png
// module id = 1950
// module chunks = 30